import { render, staticRenderFns } from "./StudentScore.vue?vue&type=template&id=06de6ae2&scoped=true"
import script from "./StudentScore.vue?vue&type=script&lang=js"
export * from "./StudentScore.vue?vue&type=script&lang=js"
import style0 from "./StudentScore.vue?vue&type=style&index=0&id=06de6ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de6ae2",
  null
  
)

export default component.exports